module.exports = "https://static.wmbcdn.com/uniweb/images/78ab90511e441d220dcdcfd6a1241a76.svg";